module.exports = __webpack_public_path__ + "img/cpe.05d228ba.png";